import { Link } from "react-router-dom";

export const PrivacyNotice = ({ checked, onChange, dark = false }) => {
  const textColor = dark ? "text-white/50" : "text-[#8A8385]";
  const headingColor = dark ? "text-white/70" : "text-[#6B6567]";
  const checkboxBorder = dark ? "border-white/20" : "border-[#D5CFC9]";
  const checkboxChecked = "bg-[#308795] border-[#308795]";
  const linkColor = dark ? "text-[#E5BD77] hover:text-[#d4ac66]" : "text-[#308795] hover:text-[#267580]";

  return (
    <div className={`text-xs leading-relaxed ${textColor} space-y-3`}>
      <p className={headingColor}>
        Asterisk Computer (FE) Pte Ltd is committed to protecting and respecting your privacy, and we'll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you.
      </p>
      <p className={textColor}>
        In order to provide you the content requested, we need to store and process your personal data. If you consent to us storing your personal data for this purpose, please tick the checkbox below.
      </p>
      <label className="flex items-start gap-3 cursor-pointer group">
        <div className="relative mt-0.5 shrink-0">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            className="sr-only"
          />
          <div
            className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 ${
              checked ? checkboxChecked : checkboxBorder
            }`}
          >
            {checked && (
              <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
        </div>
        <span className={`text-xs ${dark ? "text-white/80" : "text-[#494546]"} font-medium leading-snug`}>
          I agree to allow Asterisk Computer (FE) Pte Ltd to store and process my personal data.
        </span>
      </label>
      <p className={textColor}>
        You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our{" "}
        <Link to="/privacy" className={`font-medium underline ${linkColor} transition-colors`} onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>.
      </p>
    </div>
  );
};
